import { defineStore } from "pinia";
import { useStorage } from '@vueuse/core';

export default class UserData {

    /**
     *
     * @type {UserData}
     * @static
     * @memberof UserData
     */
    static _instance;

    userId = "3345678"


    /**
     *
     *
     * @readonly
     * @static
     * @memberof UserData
     */
    static get Instance() {
        if (this._instance == null) {
            this._instance = new UserData();
        }
        return this._instance;
    }

    get UserId() {
        return this.userId;
    }
}

export const useUserStore = defineStore("user", {
    state: () => ({
        userId: useStorage("userId", "", localStorage, { mergeDefaults: true }),
        userName: useStorage("userName", "", localStorage, { mergeDefaults: true }),
        savedAccount: useStorage("savedAccount", "", localStorage, { mergeDefaults: true }),
        savedPassword: useStorage("savedPassword", "", localStorage, { mergeDefaults: true }),
        token: useStorage("token", "", localStorage, { mergeDefaults: true }),
    })
})